var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-twitter","data-name":"Icon awesome-twitter","d":"M33.031,10.833c.023.327.023.654.023.981,0,9.975-7.592,21.468-21.468,21.468A21.322,21.322,0,0,1,0,29.894a15.609,15.609,0,0,0,1.822.093,15.111,15.111,0,0,0,9.367-3.224,7.559,7.559,0,0,1-7.055-5.233,9.515,9.515,0,0,0,1.425.117,7.98,7.98,0,0,0,1.986-.257,7.546,7.546,0,0,1-6.05-7.405v-.093a7.6,7.6,0,0,0,3.41.958A7.556,7.556,0,0,1,2.57,4.759a21.447,21.447,0,0,0,15.558,7.9,8.518,8.518,0,0,1-.187-1.729A7.552,7.552,0,0,1,31,5.763a14.855,14.855,0,0,0,4.789-1.822A7.525,7.525,0,0,1,32.47,8.1a15.126,15.126,0,0,0,4.345-1.168A16.219,16.219,0,0,1,33.031,10.833Z","transform":"translate(0 -3.381)","fill":"#fff"}));
}

Twitter.defaultProps = {"id":"twitter_icon","data-name":"twitter icon","width":"36.815","height":"29.9","viewBox":"0 0 36.815 29.9"};

module.exports = Twitter;

Twitter.default = Twitter;
